import { forwardRef, useImperativeHandle, useRef } from "react";
import { TextAreaProps } from "./TextArea.types";
import Container from "../../layout/Container";
import { StyledTextAreaInput } from "./TextArea.styles";
import Flex from "../../layout/Flex";
import Typography from "../Typography";
import COLORS from "../../constants/colors";

const TextArea = forwardRef<HTMLInputElement, TextAreaProps>(
    (props: TextAreaProps, ref) => {
        const {
            label,
            name,
            onChange,
            autoFocus,
            disabled,
            errorMsg,
            helpMsg,
            id,
            length,
            onBlur,
            onFocus,
            required,
            showCharacterCount,
            value,
            placeholder,
            width,
            rows,
            cols,
            headingLabelStyleProps,
            size = "md",
        } = props;

        const inputRef = useRef<HTMLInputElement>(null);
        useImperativeHandle(ref, () => inputRef.current!);

        const countMsg = showCharacterCount
            ? `${value?.length ?? 0} / ${length}`
            : "";

        return (
            <Container margin={0} padding={0}>
                <Flex flexDirection="column" gap={10}>
                    <Typography
                        required={required}
                        size="m"
                        {...headingLabelStyleProps}
                    >
                        {label}
                    </Typography>
                    <StyledTextAreaInput
                        placeholder={placeholder}
                        id={id}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        autoFocus={autoFocus}
                        disabled={disabled}
                        name={name}
                        maxLength={length}
                        autoCorrect={"false"}
                        autoCapitalize={"false"}
                        autoComplete={"false"}
                        width={width}
                        rows={rows}
                        cols={cols}
                        size={size}
                    />

                    <Flex justifyContent="space-between">
                        <Flex>
                            <Typography color={COLORS.GREY_400} size="sm">
                                {helpMsg}
                            </Typography>
                        </Flex>
                        <Typography color={COLORS.GREY_400} size="sm">
                            {countMsg}
                        </Typography>
                    </Flex>
                    <Typography color={COLORS.RED} size="sm">
                        {errorMsg}
                    </Typography>
                </Flex>
            </Container>
        );
    },
);

export default TextArea;
